import {
  GET_AUDIT_TRAIL,
  GET_AUDIT_TRAIL_FAILURE,
  GET_AUDIT_TRAIL_SUCCESS,
} from '../actions'
import { AuditTrail } from '../api/types'

interface AuditTrailReducer {
  loadingAuditTrail: boolean
  auditTrail?: AuditTrail[]
  errorMessage?: string
}

const INITIAL_STATE: AuditTrailReducer = {
  auditTrail: [],
  loadingAuditTrail: false,
}

export const auditTrailReducer = (
  state: AuditTrailReducer = INITIAL_STATE,
  action: {
    type: string
    auditTrail?: AuditTrail[]
    errorMessage?: string
  }
): AuditTrailReducer => {
  const { type, auditTrail, errorMessage } = action
  switch (type) {
    case GET_AUDIT_TRAIL:
      return { ...INITIAL_STATE, loadingAuditTrail: true }
    case GET_AUDIT_TRAIL_SUCCESS:
      return { ...state, loadingAuditTrail: false, auditTrail }
    case GET_AUDIT_TRAIL_FAILURE:
      return { ...state, loadingAuditTrail: false, errorMessage }
    default:
      return state
  }
}
